<template>
  <div class="div" v-loading="loading">
    <!-- <div class="title">枚举管理</div> -->
    <div class="div-top">
      <el-button icon="el-icon-plus" type="primary" @click="handleAdd"
        >新建枚举信息</el-button
      >
      <el-button
        icon="el-icon-minus"
        type="danger"
        @click="handleDetele(selectedRows)"
        :disabled="selectedRows.length === 0"
        >删除</el-button
      >
      <el-input
        v-model="searchData.Keyword"
        clearable
        placeholder="请输入枚举值或名称"
        style="width: 300px; margin-left: 10px"
      ></el-input>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px"
        >查询</el-button
      >
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        height="calc(100% - 40px)"
        @selection-change="handleSelect"
      >
        <el-table-column label="" width="50" type="selection">
        </el-table-column>
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>

        <!-- <el-table-column label="仓库" align="center" prop="StorIdName"> </el-table-column> -->
        <el-table-column label="枚举值" align="center" prop="Code" sortable>
        </el-table-column>
        <el-table-column label="枚举名称" align="center" prop="Name" sortable>
        </el-table-column>
        <el-table-column
          label="系统必须"
          align="center"
          prop="IsSystem"
          sortable
        >
          <template slot-scope="scope">
            <el-tag v-if="scope.row.IsSystem" type="success">是</el-tag>
            <el-tag v-else type="danger">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="备注" align="center" prop="Remarks">
        </el-table-column>

        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="handleList(scope.row)"
              >设置字典值</el-button
            >

            <el-button
              type="text"
              @click="handleEdit(scope.row)"
              v-if="!scope.row.IsSystem"
              >编辑</el-button
            >
            <el-button
              v-if="!scope.row.IsSystem"
              type="text"
              @click="handleDetele([scope.row])"
              style="color: #f78989"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    <EditForm ref="EditForm" @success="handleSearch" />
    <DictionaryList ref="DictionaryList"></DictionaryList>
  </div>
</template>
<script>
import EditForm from './EditForm'
import DictionaryList from './DictionaryList/DictionaryList.vue'
export default {
  data() {
    return {
      searchData: {
        Keyword: '',
      },
      tableData: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
    }
  },
  props: {},
  components: { EditForm, DictionaryList },
  methods: {
    handleList(row) {
      this.$refs.DictionaryList.openList('设置字典值', row.Id, row.Code)
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/Base/Base_Enum/GetDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'CreateTime',
          SortType: 'Desc',
          Search: this.searchData,
        })
        .then((resJson) => {
          this.loading = false
          this.tableData = resJson.Data
          this.pagination.total = resJson.Total
          this.$nextTick(() => {
            if (this.$refs.table) {
              this.$refs.table.clearSelection()
            }
          })
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      this.$refs.EditForm.openForm('新建枚举信息')
    },
    handleDetele(rows) {
      let ids = rows.map((item) => item.Id)
      this.$confirm(`此操作将永久删除该枚举信息, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http.post('/Base/Base_Enum/DeleteData', ids).then((resJson) => {
            this.loading = false
            if (resJson.Success) {
              this.$notify.success('删除成功')
              this.getDataList()
            } else {
              this.$notify.error(resJson.Msg)
            }
          })
        })
        .catch(() => {})
    },
    handleEdit(row) {
      this.$refs.EditForm.openForm('编辑枚举', row)
    },
  },
  mounted() {},
  created() {
    this.getDataList()
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 30px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
</style>
